import { IStoreLocation } from '@/actions/store-action';
import { IReducersState } from '@/reducers';
import { getI18nText, handleStoreCategoryTypesScroll } from '@/utils/app';
import React from 'react';
import { getIntl } from '@/components/App/App';

export const prefix = 'bm-p-stores-by-category-types';

interface ICategoryTypesProps {
  data: IStoreLocation[];
  className?: string;
  selected: string;
  reducersState: IReducersState;
  onItemClick?: (type: string) => void;
}

const LocationTypes: React.FC<ICategoryTypesProps> = props => {
  const {
    data,
    className = '',
    selected,
    reducersState,
    onItemClick,
  } = props;

  const handleItemClick = (type: string) => {
    handleStoreCategoryTypesScroll(type);
    if (onItemClick) {
      onItemClick(type);
    }
  }

  return (
    <div id="bm-store-service-types-box" className={`${prefix} ${className}`}>
      <div id="bm-store-service-types" className={`${prefix}-wrapper`}>
        <div
          id="bm-store-service-types"
          className={`${prefix}-item ${('0') === selected ? 'selected' : ''}`}
          onClick={() => handleItemClick('0')}
        >
          {getIntl().page.all}
        </div>
        {
          data.map(item => {
            return (
              <div
                key={item.id}
                id={`bm-store-service-types-${item.id}`}
                className={`${prefix}-item ${item.id === selected ? 'selected' : ''}`}
                onClick={() => handleItemClick(item.id)}
              >
                {getI18nText(item, 'district', reducersState.app.language)}
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default LocationTypes;
